import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface LoginInterface {
  username: string;
  password: string;
}

export const useLogin = () => {
  const mutate = useMutation(({ username, password }: LoginInterface) => {
    return get(
      `/external-api/access_token?grant_type=password&username=${username}&password=${password}`,
      {
        headers: {
          authorization: 'Bearer QUlfVlJQb3J0YWxfQXBwNDAwMDpSZmFjdG9yeUBEMjAyNSE1MDAw',
        },
      },
    );
  });

  return mutate;
};

export default useLogin;
